import * as CryptoJS from 'crypto-js';
import jwt_decode from 'jwt-decode';
import { BehaviorSubject, Observable } from 'rxjs';
import { statusAtivo } from '../modules/_models/statusMembroLogin.model';
import { User } from '../modules/_models/user';

export class LocalStorageUtils {
  private currentUserTokenSubject: BehaviorSubject<User>;
  public currentUserToken: Observable<User>;

  private currentUserNivelSubject: BehaviorSubject<number>;
  public currentUserNivel: Observable<number>;

  private currentUserMembroSubject: BehaviorSubject<any>;
  public currentUserMembro: Observable<any>;

  private currentUserDadosValidadosSubject: BehaviorSubject<boolean>;
  public currentUserDadosValidados: Observable<boolean>;

  private currentSessaoAppSubject: BehaviorSubject<boolean>;
  public currentSessaoApp: Observable<boolean>;

  private currentUserRedirectLinkSubject: BehaviorSubject<string>;
  public currentUserRedirectLink: Observable<string>;

  private key = 'cacau@CSAzure';

  constructor() {
    this.currentSessaoAppSubject = new BehaviorSubject<boolean>(
      JSON.parse(this.obterSessaoApp())
    );
    this.currentSessaoApp = this.currentSessaoAppSubject.asObservable();

    this.currentUserTokenSubject = new BehaviorSubject<User>(
      JSON.parse(this.obterObtejo())
    );
    this.currentUserToken = this.currentUserTokenSubject.asObservable();

    this.currentUserNivelSubject = new BehaviorSubject<number>(
      JSON.parse(this.obterNivel())
    );
    this.currentUserNivel = this.currentUserNivelSubject.asObservable();

    this.currentUserMembroSubject = new BehaviorSubject<number>(
      this.obterMembro()
    );
    this.currentUserMembro = this.currentUserMembroSubject.asObservable();

    this.currentUserDadosValidadosSubject = new BehaviorSubject<boolean>(
      JSON.parse(this.obterDadosValidados())
    );
    this.currentUserDadosValidados =
      this.currentUserDadosValidadosSubject.asObservable();

    this.currentUserRedirectLinkSubject = new BehaviorSubject<string>(
      JSON.parse(this.obterRedirectLink())
    );
    this.currentUserRedirectLink =
      this.currentUserRedirectLinkSubject.asObservable();
  }

  public salvarDadosLocaisUsuario(response: statusAtivo) {
    if (response.token) {
      this.salvarObjeto(response);
      this.currentUserTokenSubject.next(response);
    }
  }

  public removerDados(remover: string) {
    localStorage.removeItem(remover);
  }

  public limparDadosLocaisUsuario() {
    localStorage.removeItem('fidelidade.token');
    localStorage.removeItem('nivel');
    localStorage.removeItem('membro');
    localStorage.removeItem('dadosValidados');
    localStorage.removeItem('redirectLink');
    localStorage.removeItem('popupAlertaVencimentoCacaus');
  }

  public desconectar() {
    localStorage.removeItem('fidelidade');
    localStorage.removeItem('nivel');
    localStorage.removeItem('membro');
    localStorage.removeItem('dadosValidados');
    localStorage.removeItem('redirectLink');
    localStorage.removeItem('popupAlertaVencimentoCacaus');
    localStorage.removeItem('sessao_app');
    this.currentUserTokenSubject.next(null);
    this.currentUserMembroSubject?.next(undefined);
  }

  public obterObtejo() {
    return localStorage.getItem('fidelidade');
  }

  public obterObtejoLocal(item: string) {
    return localStorage.getItem(item);
  }

  public obterObjetoUsuario() {
    const fidelidade = this.obterObtejo();
    if (fidelidade) {
      const token = JSON.parse(fidelidade).token;
      if (token) {
        return jwt_decode(token);
      } else {
        return {};
      }
    }
  }

  public obterToken(): string {
    const user: any = JSON.parse(this.obterObtejo());

    if (user) {
      const token = user.token;

      if (token === undefined) {
        return '';
      }
      return token;
    }

    return '';
  }

  public usuarioValido(): boolean {
    const user: any = this.obterObjetoUsuario();

    return user;
  }

  public tokenEstaExpirado(user: any): boolean {
    const nowTimestamp: number = Date.now();
    const expiresTimestamp: number = user.exp * 1000;

    if (nowTimestamp > expiresTimestamp) {
      return true;
    }

    return false;
  }

  public salvarObjeto(response: statusAtivo) {
    localStorage.setItem('fidelidade', JSON.stringify(response));
  }

  public salvarObjetoLocal(item: string, valor: any) {
    localStorage.setItem(item, JSON.stringify(valor));
  }

  public salvarSessaoApp(response: string, value: number) {
    localStorage.setItem(`${response}`, JSON.stringify(value));
    this.currentSessaoAppSubject.next(value == 1 ? true : false);
  }

  public salvarNivel(idNivel: number) {
    localStorage.setItem('nivel', JSON.stringify(idNivel));
    this.currentUserNivelSubject.next(idNivel);
  }

  public salvarMembro(membro: any) {
    localStorage.setItem('membro', this.encrypt(JSON.stringify(membro)));
    this.currentUserMembroSubject.next(membro);
  }

  public salvarDadosValidados(dadosValidados: boolean) {
    localStorage.setItem('dadosValidados', JSON.stringify(dadosValidados));
    this.currentUserDadosValidadosSubject.next(dadosValidados);
  }

  public obterNivel() {
    return localStorage.getItem('nivel');
  }

  public obterMembro() {
    var membro = localStorage.getItem('membro');

    if (membro == '' || membro === undefined || membro == null)
      this.desconectar();
    else return JSON.parse(this.decrypt(membro));
  }

  public obterSessaoApp() {
    return localStorage.getItem('sessao_app');
  }

  public obterDadosValidados() {
    return localStorage.getItem('dadosValidados');
  }

  public obterRedirectLink() {
    return localStorage.getItem('redirectLink');
  }

  public obterAlertaVencimentoCacaus() {
    return localStorage.getItem('popupAlertaVencimentoCacaus');
  }

  public salvarRedirectLink(redirectLink: string) {
    localStorage.setItem('redirectLink', JSON.stringify(redirectLink));
    this.currentUserRedirectLinkSubject.next(redirectLink);
  }

  public salvarAlertaVencimentoCacaus() {
    localStorage.setItem('popupAlertaVencimentoCacaus', JSON.stringify(true));
  }

  private encrypt(obj: string): string {
    return CryptoJS.AES.encrypt(obj, this.key).toString();
  }
  private decrypt(obj: string) {
    return CryptoJS.AES.decrypt(obj, this.key).toString(CryptoJS.enc.Utf8);
  }

  public salvarLinkIndicacao(link: string) {
    localStorage.setItem('linkIndicacao', link);
  }
}
